import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import {
  Box,
  Collapse,
  Link as MuiLink,
  Stack,
  Typography,
} from "@mui/material";
import Link from "next/link";
import * as React from "react";

const ChildrenCategory = ({ name, href, isBold }) => {
  return (
    <Link href={href}>
      <MuiLink
        variant={isBold ? "subtitle2" : "body2"}
        underline="hover"
        color="inherit"
        href={href}
      >
        {name}
      </MuiLink>
    </Link>
  );
};

export default function CateogryTopMenu({
  open = false,
  name,
  allHref,
  childrenItems = [],
}) {
  const [isOpen, setOpen] = React.useState(open);
  const hasChildren = React.useMemo(() => {
    return childrenItems.length > 0;
  }, [childrenItems]);

  const switchOpen = () => {
    setOpen(!isOpen);
  };

  return (
    <Box>
      <Box
        sx={{
          // bgcolor: "grey.200",
          // px: 2,
          py: 1.25,
          borderRadius: 1,
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={switchOpen}
      >
        {/* {icon} */}
        <Typography
          variant="body1"
          sx={{
            ml: 2,
            fontWeight: (theme) => theme.typography.fontWeightSemiBold,
          }}
        >
          {name}
        </Typography>
        {hasChildren && (
          <KeyboardArrowUpIcon
            sx={{
              ml: "auto",
              transform: isOpen ? "rotate(180deg)" : '"rotate(0deg)"',
            }}
          />
        )}
      </Box>
      {hasChildren && (
        <Collapse in={isOpen}>
          <Stack spacing={1.5} sx={{ pl: 3, pt: 1.5, pb: 0.5 }}>
            {allHref && (
              <ChildrenCategory name={`All ${name}`} href={allHref} isBold />
            )}
            {childrenItems.map((item) => {
              return <ChildrenCategory key={item.slug} {...item} />;
            })}
          </Stack>
        </Collapse>
      )}
    </Box>
  );
}
